<template>
  <v-container class="d-flex flex-row" style="height: 100%; width: 800px">
    <div v-if="!dialog" class="pt-6 ml-n9">
      <v-btn @click="$router.go(-1)" icon>
        <v-icon>
          mdi-arrow-left
        </v-icon>
      </v-btn>
    </div>

    <div class="fill-width">
      <v-card color="transparent" flat>
        <v-card-title v-if="!dialog">
          {{ tid ? "Editar pago" : "Nuevo pago" }}
        </v-card-title>
      </v-card>

      <v-card class="mx-3">
        <v-card-text>
          <v-form lazy-validation v-model="valid" ref="form">
            <v-row>
              <v-col cols="4" class="pt-0">
                <v-autocomplete
                  v-model="accountId"
                  label="Cuenta"
                  :items="accounts"
                  item-text="name"
                  item-value="id"
                  filled
                  hint="Obligatorio"
                  :rules="rules.required"
                  persistent-hint
                ></v-autocomplete>
              </v-col>

              <v-col cols="4" class="pt-0">
                <v-select
                  v-model="subAccountId"
                  :disabled="!(accountId && subaccounts.length)"
                  label="Subcuenta"
                  :items="subaccounts"
                  item-text="name"
                  item-value="id"
                  filled
                  hint="Obligatorio"
                  :rules="rules.required"
                  persistent-hint
                ></v-select>
              </v-col>

              <v-col cols="4" class="pt-0">
                <v-autocomplete
                  :disabled="!(subAccountId && concepts.length)"
                  v-model="concept"
                  label="Concepto"
                  :items="concepts"
                  item-text="name"
                  return-object
                  filled
                  hint="Obligatorio"
                  :rules="rules.required"
                  persistent-hint
                ></v-autocomplete>
              </v-col>
            </v-row>

            <v-row>
              <v-col class="py-0" cols="3">
                <v-select
                  :rules="rules"
                  :items="contractSplitOptions"
                  v-model="tax.interval"
                  filled
                  hint="*Obligatorio"
                  persistent-hint
                  label="Frecuencia de pago"
                >
                </v-select>
              </v-col>
              <v-col class="py-0" cols="3">
                <v-text-field
                  v-model.number="tax.dueAt"
                  type="number"
                  filled
                  label="Día de vencimiento"
                >
                </v-text-field>
              </v-col>
              <template
                v-if="['Contract', 'User', 'Building'].includes(object)"
              >
                <v-col class="pt-0" cols="3">
                  <v-menu
                    v-model="startMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="tax.startsAt"
                        :rules="rules"
                        label="Inicio"
                        append-icon="mdi-calendar-blank"
                        readonly
                        filled
                        hint="*Obligatorio"
                        persistent-hint
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="tax.startsAt"
                      @input="startMenu = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col class="pt-0" cols="3">
                  <v-menu
                    v-model="endMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="tax.endsAt"
                        label="Fin"
                        append-icon="mdi-calendar-blank"
                        readonly
                        filled
                        hide-details="auto"
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="tax.endsAt"
                      :min="new Date().toISOString().substr(0, 10)"
                      @input="endMenu = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </template>
            </v-row>

            <v-row>
              <v-col class="py-0" cols="6">
                <v-text-field
                  v-model.number="tax.amount"
                  filled
                  type="number"
                  hint="*Obligatorio"
                  persistent-hint
                  suffix="$"
                  label="Monto"
                >
                </v-text-field>
              </v-col>

              <v-col class="pt-0" cols="3">
                <v-text-field
                  v-model="tax.chargeback"
                  filled
                  hide-details
                  label="% recargo por mora"
                >
                </v-text-field>
              </v-col>

              <v-col class="pt-0" cols="3">
                <v-btn-toggle v-model="tax.billed" class="fill-width" mandatory>
                  <v-btn
                    :value="true"
                    color="white"
                    active-class="blue lighten-1 white--text py-5"
                    style="width: 50%; height: auto !important"
                  >
                    FC
                  </v-btn>
                  <v-btn
                    :value="false"
                    color="white"
                    style="width: 50%; height: auto !important"
                    active-class="blue lighten-1 white--text py-5"
                  >
                    NO/FC
                  </v-btn>
                </v-btn-toggle>
              </v-col>
            </v-row>

            <v-card flat class="background rounded-lg mt-3">
              <v-card-text>
                <v-row>
                  <template v-if="object && object == 'Building'">
                    <v-col cols="12">
                      <v-card outlined class="rounded-lg">
                        <v-card-title>
                          ¿Aplica para los departamentos vacíos?
                        </v-card-title>

                        <v-card-text>
                          <v-radio-group v-model="tax.appliesWhenEmpty">
                            <v-radio
                              v-for="act in [true, false]"
                              :key="act"
                              :label="act ? 'Sí' : 'No'"
                              :value="act"
                            ></v-radio>
                          </v-radio-group>
                        </v-card-text>
                      </v-card>
                    </v-col>

                    <v-col cols="12" v-if="tax.appliesWhenEmpty">
                      <v-card outlined class="rounded-lg">
                        <v-card-title>
                          ¿Quién cubre el gasto?
                        </v-card-title>

                        <v-card-text>
                          <v-radio-group v-model="tax.emptyAction">
                            <v-radio
                              v-for="act in ['all', 'owner']"
                              :key="act"
                              :label="
                                act == 'all'
                                  ? 'Se reparte entre los demás inquilinos'
                                  : 'El dueño'
                              "
                              :value="act"
                            ></v-radio>
                          </v-radio-group>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </template>

                  <template v-if="!object || !(object == 'User')">
                    <v-col cols="12">
                      <v-card outlined class="rounded-lg">
                        <v-card-title>
                          Locatario
                        </v-card-title>

                        <v-card-text>
                          <v-radio-group v-model="tax.tenantAction">
                            <v-radio
                              v-for="act in ['none', 'add', 'substract']"
                              :key="act"
                              :label="$t('tenantActions.' + act)"
                              :value="act"
                            ></v-radio>
                          </v-radio-group>
                        </v-card-text>
                      </v-card>
                    </v-col>

                    <v-col cols="12">
                      <v-card outlined class="rounded-lg">
                        <v-card-title>
                          Locador
                        </v-card-title>

                        <v-card-text>
                          <v-radio-group v-model="tax.ownerAction">
                            <v-radio
                              v-for="act in ['none', 'substract', 'add']"
                              :key="act"
                              :label="$t('ownerActions.' + act)"
                              :value="act"
                            ></v-radio>
                          </v-radio-group>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </template>

                  <v-col v-else cols="12">
                    <v-card outlined class="rounded-lg">
                      <v-card-title>
                        Tipo de pago
                      </v-card-title>

                      <v-card-subtitle>
                        Desde el punto de vista del cliente.
                      </v-card-subtitle>

                      <v-card-text>
                        <v-radio-group v-model="tax.agencyAction">
                          <v-radio
                            v-for="act in ['add', 'substract']"
                            :key="act"
                            :label="$t('agencyActions.' + act)"
                            :value="act"
                          ></v-radio>
                        </v-radio-group>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <v-card flat class="background rounded-lg mt-3">
              <v-card-text>
                <v-row>
                  <template v-if="object && object == 'Building'">
                    <v-col cols="12">
                      <v-card outlined class="rounded-lg">
                        <v-card-title>
                          ¿Diferente porcentaje de pago para cada unidad?
                        </v-card-title>

                        <v-card-text>
                          <v-radio-group v-model="tax.unequalSplit">
                            <v-radio
                              v-for="act in [true, false]"
                              :key="act"
                              :label="act ? 'Sí' : 'No'"
                              :value="act"
                            ></v-radio>
                          </v-radio-group>
                        </v-card-text>
                      </v-card>
                    </v-col>

                    <template v-if="tax.unequalSplit && building">
                      <template v-for="percentage in tax.percentagesAttributes">
                        <v-col cols="6">
                          <v-card outlined class="rounded-lg">
                            <v-card-title class="body-2">
                              <div class="line-clamp">
                                {{
                                  building.properties.find(
                                    p => p.id === percentage.propertyId
                                  ).fullAddress
                                }}
                              </div>
                            </v-card-title>

                            <v-card-text>
                              <v-text-field
                                v-model.number="percentage.amount"
                                filled
                                type="number"
                                hint="*Obligatorio"
                                persistent-hint
                                suffix="%"
                                label="Porcentaje"
                                @change="updatePercentages"
                              >
                              </v-text-field>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </template>

                      <v-col cols="12">
                        <v-card outlined class="rounded-lg">
                          <v-card-title style="gap: 8px">
                            Porcentaje acumulado:

                            <span
                              :class="
                                totalPercentage == 100
                                  ? 'success--text'
                                  : 'error--text'
                              "
                            >
                              {{ totalPercentage }}%
                            </span>
                          </v-card-title>
                        </v-card>
                      </v-col>
                    </template>
                  </template>
                </v-row>
              </v-card-text>
            </v-card>
          </v-form>
        </v-card-text>
      </v-card>

      <div class="pa-3 justify-end d-flex">
        <v-btn @click="createTax" color="primary">
          {{ tid ? "Actualizar pago" : "Agregar pago" }}
        </v-btn>
      </div>
    </div>
  </v-container>
</template>

<script>
import { Accounts } from "@/graphql/queries/account";
import { SubAccounts } from "@/graphql/queries/subAccount";
import { Concepts } from "@/graphql/queries/concepts";

import { EditTax, CreateTax } from "@/graphql/mutations/taxes";
import { Contract } from "@/graphql/queries/contract";
import { Property } from "@/graphql/queries/property";
import { Tax } from "@/graphql/queries/tax";
import { Building } from "@/graphql/queries/buildings";

export default {
  props: {
    objectType: {
      type: String,
      default: "Contract"
    },

    tid: {
      type: Number | String,
      required: false
    },

    id: {
      type: Number | String,
      required: true
    },

    dialog: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data() {
    return {
      valid: true,
      accounts: [],
      subaccounts: [],
      concepts: [],
      accountId: null,
      subAccountId: null,
      concept: null,
      building: null,
      totalPercentage: 0,
      tax: {
        name: null,
        appliesWhenEmpty: false,
        unequalSplit: false,
        emptyAction: "none",
        chargeback: 0,
        interval: null,
        startsAt: null,
        endsAt: null,
        dueAt: 10,
        taxableId: null,
        taxableType: "Contract",
        agencyAction: "none",
        tenantAction: "add",
        ownerAction: "none",
        conceptId: null,
        state: "ongoing",
        percentagesAttributes: []
        /*
        pricesAttributes: [
          {
            amount: null,
            referralId: null,
            referralType: null,
            receiverId: null,
            receiverType: null,
            sign: "+",
            startsAt: null,
            endsAt: null,
            dueAt: 10
          }
        ]
        */
      },
      contractSplitOptions: [
        {
          text: "Mensual",
          value: 1
        },
        {
          text: "Bimestral",
          value: 2
        },
        {
          text: "Trimestral",
          value: 3
        },
        {
          text: "Cuatrimestral",
          value: 4
        },
        {
          text: "Semestral",
          value: 6
        },
        {
          text: "Anual",
          value: 12
        }
      ],
      referral: [
        {
          name: null,
          referralType: null,
          referralId: null
        }
      ],
      receiver: [
        {
          name: null,
          receiverType: null,
          receiverId: null
        }
      ],
      contract: null,
      startMenu: false,
      endMenu: false,
      fee: null,
      feeSplit: null,
      resetSplit: null,
      periods: null,
      rules: [v => !!v || "*Obligatorio"]
    };
  },

  watch: {
    "tax.percentagesAttributes": {
      deep: true,

      handler(percentages) {
        this.updatePercentages();
      }
    },

    concept: {
      handler(val) {
        this.tax.name = val.name;
        this.tax.conceptId = val.id;
      },

      deep: true
    },

    subAccountId() {
      this.fetchConcepts();
    },

    accountId() {
      this.fetchSubAccounts();
    }
  },

  created() {
    this.fetchObject();
    this.fetchAccounts();
    this.tax.taxableType = this.$route.query.objectType || this.objectType;
  },

  computed: {
    referrals() {
      if (!this.contract) return [];
      let property =
        this.object == "Property" ? this.contract : this.contract.property;
      return [
        {
          name: "Locatario",
          referralId: (this.contract.tenant || [{}])[0].id,
          referralType: "User"
        },
        {
          name: "Locador",
          referralId: this.contract.owner[0].id,
          referralType: "User"
        },
        {
          name: "Inmobiliaria",
          referralId: property.agencyId,
          referralType: "Agency"
        }
      ];
    },

    receivers() {
      if (!this.contract) return [];
      let property =
        this.object == "Property" ? this.contract : this.contract.property;
      return [
        { name: "Externo", receiverId: null, receiverType: null },
        {
          name: "Locatario",
          receiverId: (this.contract.tenant || [{}])[0].id,
          receiverType: "User"
        },
        {
          name: "Locador",
          receiverId: this.contract.owner[0].id,
          receiverType: "User"
        },
        {
          name: "Inmobiliaria",
          receiverId: property.agencyId,
          receiverType: "Agency"
        }
      ];
    },

    object() {
      return this.$route.query.objectType || this.objectType;
    }
  },

  methods: {
    updatePercentages() {
      this.totalPercentage = this.tax.percentagesAttributes.reduce(
        (total, percentage) => parseInt(percentage.amount) + total,
        0
      );
    },

    fetchObject() {
      if (["User", "Building"].includes(this.object)) {
        this.tax.taxableId = this.$route.params.id;

        if (this.tid) this.fetchTax();

        if (this.object === "Building") this.fetchBuilding();
      } else {
        let query = this.object == "Property" ? Property : Contract;
        this.$apollo
          .query({
            query: query,
            variables: {
              id: this.id
            },
            fetchPolicy: "no-cache"
          })
          .then(res => {
            if (this.object == "Contract") {
              this.contract = res.data.contract;
            } else {
              this.contract = res.data.property;
            }

            if (this.contract) {
              if (!this.tax.startsAt)
                this.tax.startsAt = this.contract.startsAt;
              if (!this.tax.endsAt) this.tax.endsAt = this.contract.endsAt;

              this.tax.taxableId = this.contract.id;
            }

            if (this.tid) {
              this.fetchTax();
            }
          });
      }
    },

    fetchBuilding() {
      this.$apollo
        .query({
          query: Building,
          variables: {
            id: this.id
          },
          fetchPolicy: "no-cache"
        })
        .then(res => {
          this.building = res.data.building;

          if (this.tax.percentagesAttributes.length === 0) {
            this.building.properties.forEach(property => {
              this.tax.percentagesAttributes.push({
                amount: 0,
                propertyId: property.id
              });
            });
          }
        });
    },

    fetchTax() {
      this.$apollo
        .query({
          query: Tax,
          variables: {
            id: this.tid
          },
          fetchPolicy: "no-cache"
        })
        .then(res => {
          this.tax = {
            ...res.data.tax
          };

          let referrals = [];
          let receivers = [];
          this.tax.percentagesAttributes = [];

          this.accountId = res.data.tax.accountId;
          this.subAccountId = res.data.tax.subAccountId;

          this.concept = this.tax.concept;
          if (!this.tax.dueAt) this.tax.dueAt = 10;

          delete this.tax.concept;

          this.referral = referrals;
          this.receiver = receivers;

          if (this.tax.percentages.length)
            this.tax.percentages.map(p => {
              this.tax.percentagesAttributes.push({
                id: p.id,
                amount: p.amount,
                propertyId: p.propertyId
              });
            });

          delete this.tax.percentages;
        });
    },

    fillName(price, type) {
      if (type == "receiver" && !price.receiverType) {
        return "Externo";
      }
      if (type == "referral") {
        return price.referralId == this.contract.owner[0].id
          ? "Locador"
          : "Locatario";
      } else {
        return price.receiverId == this.contract.owner[0].id
          ? "Locador"
          : "Locatario";
      }
    },

    createTax() {
      if (this.valid) this.valid = this.$refs.form.validate();

      if (this.valid) {
        let tid = this.tid;
        let mutation = tid ? EditTax : CreateTax;
        let edit = tid ? { taxId: tid } : {};
        delete this.tax.__typename;
        delete this.tax.accountId;
        delete this.tax.subAccountId;

        this.$apollo
          .mutate({
            mutation: mutation,
            variables: {
              input: {
                attributes: this.tax,
                ...edit
              }
            }
          })
          .then(res => {
            if (this.dialog) {
              this.$emit("created");
            } else if (this.object == "Contract") {
              // this.$router.push({ name: 'Contract', id: this.id})
              this.$emit("created");
            } else if (this.object == "User") {
              this.$router.push({ name: "user_taxes", id: this.id });
            } else if (this.object == "Building") {
              this.$router.push({ name: "show_building", id: this.id });
            } else {
              this.$router.push({ name: "Property", id: this.id });
            }
          });
      }
    },

    fetchAccounts() {
      this.$apollo
        .query({
          query: Accounts,
          fetchPolicy: "no-cache"
        })
        .then(res => {
          this.accounts = res.data.accounts;
          this.count += 1;
          this.$forceUpdate();
        });
    },

    fetchSubAccounts() {
      this.$apollo
        .query({
          query: SubAccounts,
          variables: {
            isolated: false,
            accountId: this.accountId
          },
          fetchPolicy: "no-cache"
        })
        .then(res => {
          this.subaccounts = res.data.subAccounts;
        });
    },

    fetchConcepts() {
      this.$apollo
        .query({
          query: Concepts,
          variables: {
            subAccountId: this.subAccountId
          },
          fetchPolicy: "no-cache"
        })
        .then(res => {
          this.concepts = res.data.concepts;
        });
    }
  }
};
</script>
